import { useState } from "react"

const ToggleButton = ({
  initialOpen = false,
  openLabel = "Hide Filters",
  closedLabel = "Show Filters",
  onToggle, // optional callback
  children,
}) => {
  const [isOpen, setIsOpen] = useState(initialOpen)

  const handleToggle = () => {
    setIsOpen(prev => !prev)
    if (onToggle) onToggle(!isOpen)
  }

  return (
    <>
      <div className="mb-2 d-flex justify-content-end">
        <button
          className="btn btn-outline-primary btn-sm"
          onClick={handleToggle}
        >
          {isOpen ? `${openLabel} ▲` : `${closedLabel} ▼`}
        </button>
      </div>

      {isOpen && children}
    </>
  )
}

export default ToggleButton
